import * as React from "react";
import { Notice, Text, Button } from "telia-front-react";
class PaymentSuccessfulNotice extends React.Component {
  constructor(props) {
    super(props);
  }
  render() {
    const { title, closeButtonLabel, paymentSuccessInfo } = this.props;
    return /* @__PURE__ */ React.createElement(Notice, { type: "success", direction: "vertical" }, /* @__PURE__ */ React.createElement(Text, null, typeof title === "string" ? /* @__PURE__ */ React.createElement("h2", { className: "text__margin-half" }, title) : /* @__PURE__ */ React.createElement("h2", { className: "text__margin-half", dangerouslySetInnerHTML: title }), paymentSuccessInfo && /* @__PURE__ */ React.createElement("p", null, paymentSuccessInfo), this.props.onCloseButton && /* @__PURE__ */ React.createElement(Button, { text: closeButtonLabel, variant: "secondary", onClick: this.props?.onCloseButton })));
  }
}
export {
  PaymentSuccessfulNotice as default
};
